import styled from '@app/styled';
import { spacing } from '@app/theme';

export const Container = styled.div`
    padding: ${spacing(5, 7, 4, 7)};
    // to make it sync with old twig layout
    padding-left: 30px;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const ProjectBody = styled.div`
    flex-grow: 1;
    flex-shrink: 0;
`;
